// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__3S5pY","rootCenter":"LoadMoreObserver_rootCenter__3V8F1","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__kQpu0"};